import moment from 'moment-timezone'

import type { Request } from '../../../../index'
import type {
  MachineChanges,
  MachineChangesParams,
} from 'app/common/types/vending/machines/changes'

type PathParamsDto = { machineId: number }
type ParamsDto = {
  action_id?: 1 | 2 | 3 | 4
  limit?: number
  offset?: number
}
type ResultDto = {
  changes_count: number
  changes: Record<
    string,
    {
      id: number
      created: string
      source: string
      actor: string
      description: string
    }
  >
}

export const convertParams = ({
  machineId,
  actionId,
  limit,
  offset,
}: MachineChangesParams): [ParamsDto, PathParamsDto] => [
  { ...(actionId ? { action_id: actionId } : {}), limit, offset },
  { machineId },
]

export const convertResult = (data: ResultDto): MachineChanges => ({
  items: Object.values(data.changes)
    .sort((a, b) => moment(b.created).valueOf() - moment(a.created).valueOf() || b.id - a.id)
    .map((item) => ({
      ...item,
      id: String(item.id),
      created: moment(item.created).format('DD.MM.YYYY HH:mm:ss'),
    })),
  count: data.changes_count,
})

export const GET_VENDING_MACHINE_CHANGES: Request<MachineChangesParams, MachineChanges, PathParamsDto> =
  ['data/vending/machines/{machineId}/changes', 'get', ['data']]
